// Core-identical cart toasts — match storefront.cart.js `addToCartSuccess` so
// ALL parts-finder add-to-cart feedback (result cards, alternatives, sliders,
// oil guides, PDP) looks the same as the rest of the store: title
// "Item successfully added", body of the product name + "Qty: N" + a View Cart
// link, using the theme-styled .toast-cart-* / .toast-footer classes. Our old
// toast said "Add to Cart" / "Item added to cart." which looked different.

export function addedToCartToast(name, qty) {
	var q = qty > 0 ? qty : 1;
	var plural = q > 1 ? 's' : ''; // matches core (appended to the name)
	var message =
		'<div class="toast-cart-body"><div>' +
		'<div class="toast-cart-name">' + (name || 'Item') + plural + '</div>' +
		'<div class="toast-cart-qty">Qty: <strong>' + q + '</strong></div>' +
		'</div></div>' +
		'<div class="toast-footer"><a href="/checkout/cart" class="toast-view-cart">View Cart</a></div>';
	return { style: 'success', title: 'Item successfully added', message: message };
}

export function addFailedToast(message) {
	return { style: 'error', title: 'Item could not be added', message: '<div class="toast-cart-body"><div>' + message + '</div></div>' };
}
